<template>
    <svg :width="width" :height="height" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.1865 19.7734L30.665 28.2519" :stroke="color" stroke-width="2" stroke-miterlimit="10"
            stroke-linecap="round" />
        <path d="M10.9908 8.57812L14.4213 12.0086" :stroke="color" stroke-width="2" stroke-miterlimit="10"
            stroke-linecap="round" />
        <path d="M29.4228 23.5156L25.9286 27.0097" :stroke="color" stroke-width="2" stroke-miterlimit="10"
            stroke-linecap="round" />
        <path
            d="M7.17098 3.40069L11.5264 7.75606L10.1672 9.11519L5.81185 4.75982C5.58625 4.53422 5.58625 4.16482 5.81185 3.93922L6.35038 3.40069C6.57598 3.17508 6.94538 3.17508 7.17098 3.40069Z"
            :fill="color" :stroke="color" stroke-width="2" />
        <path d="M19.6142 22.1924L28.1629 30.7389" :stroke="color" stroke-width="2" stroke-miterlimit="10"
            stroke-linecap="round" />
        <path d="M8.98038 11.5566L11.7414 14.3177" :stroke="color" stroke-width="2" stroke-miterlimit="10"
            stroke-linecap="round" />
        <path d="M26.9185 26.0024L23.4265 29.4966" :stroke="color" stroke-width="2" stroke-miterlimit="10"
            stroke-linecap="round" />
        <path
            d="M5.37688 5.18528L10.4332 10.2416L7.66291 13.0118L2.60664 7.95552C1.99052 7.33939 1.99052 6.33683 2.60664 5.7207L3.14207 5.18528C3.75819 4.56915 4.76076 4.56915 5.37688 5.18528Z"
            :fill="color" />
        <path
            d="M29.8463 10.1957L30.0307 7.68262L27.5176 7.86698C26.4554 8.00306 25.4655 8.48811 24.7083 9.24531L7.22675 26.7269C6.32469 27.6289 6.32469 29.0907 7.22675 29.9927L7.72277 30.4888C8.62483 31.3908 10.0866 31.3908 10.9886 30.4888L28.468 13.005C29.2252 12.2478 29.7103 11.2579 29.8463 10.1957Z"
            fill="white" :stroke="color" stroke-width="2" stroke-linejoin="round" />
        <path
            d="M26.0845 6.43589L26.2689 3.92285L23.7558 4.10721C22.6935 4.24329 21.7037 4.72834 20.9465 5.48555L3.46491 22.9649C2.56285 23.867 2.56285 25.3287 3.46491 26.2308L3.96093 26.7268C4.86299 27.6289 6.32473 27.6289 7.22679 26.7268L24.7084 9.24523C25.4656 8.48803 25.9506 7.49818 26.0867 6.43589L26.0845 6.43589Z"
            :stroke="color" stroke-width="2" stroke-linejoin="round" />
    </svg>
</template>

<script>
export default {
    name: "MaterielSVG",
    props: {
        color: {
            type: String,
            default: 'black'
        },
        width: {
            type: String,
            default: '34'
        },
        height: {
            type: String,
            default: '20'
        }
    },
}
</script>